module.exports = __webpack_public_path__ + "static/img/user.9b92b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.jpg
// module id = ZJ6t
// module chunks = 51